import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

import Icon from "./Icon";
import { convertRoleToPath } from "../utils/enum";

const BottomTab = () => {
  const auth = useSelector((state) => state.auth);

  const tabs = [
    {
      icon: "solar:home-smile-angle-broken",
      text: "خانه",
    },
    auth.isAdmin && {
      icon: "solar:users-group-two-rounded-broken",
      text: "کاربران",
      link: "/users",
    },
    {
      icon: "solar:reorder-broken",
      text: "سفارشات",
      link: "/orders",
    },
    auth.isAdmin && {
      icon: "solar:dialog-broken",
      text: "پیامک های انبوه",
      link: "/bulk-sms",
    },
    {
      icon: "solar:user-broken",
      text: "حساب کاربری",
      link: "/profile",
    },
  ].filter(Boolean);

  return (
    <div
      className="d-xl-none bottom-tab d-footer w-100 position-fixed border-top"
      style={{ bottom: 0, left: 0 }}
    >
      {tabs.map((tab, index) => {
        const linkUrl = `/${convertRoleToPath(auth.role)}${tab.link || ""}`;
        return (
          <div className="col px-0" key={linkUrl}>
            <NavLink
              to={linkUrl}
              className={`bottom-tab-item ${
                index + 1 === Math.ceil(tabs.length / 2)
                  ? "bottom-tab-item-center"
                  : ""
              }`}
              end
            >
              <Icon icon={tab.icon} className="text-xxl" />
              <span className="d-block">{tab.text}</span>
            </NavLink>
          </div>
        );
      })}
    </div>
  );
};

export default BottomTab;
